<div #component class="options-wrapper" @enter>
  <app-auth-header [title]="messageHeader()"></app-auth-header>
  <div class="container">
    <div class="header">
      <h3>¡Bienvenido de nuevo!</h3>
      @if (mode=='acceder') {
        <p>Inicia sesión para acceder a tu cuenta de Miloto... ¡La suerte te espera!</p>
      }
      @if (mode=='registrate') {
        <p>Registrate para acceder a Miloto... ¡La suerte te espera! </p>
      }
    </div>
    <div class="body">
      <div class="buttons">
        @if (mode=='acceder') {
          <button class="btn btn-secondary" routerLink="/acceso/inicia-sesion">Accede con
          &#64;email</button>
        }
        @if (mode=='registrate') {
          <button class="btn btn-secondary" routerLink="/acceso/registro">Registrar con
          &#64;email</button>
        }

        <asl-google-signin-button class="btn" type='standard' size='large' shape='circle' theme='outline'
        text="continue_with" logo_alignment="center" locale="es" width="320"></asl-google-signin-button>

        <button class="btn" (click)="loginApple($event)">
          <img src="/assets/images/icons/appel_icon.png" />
          <span>{{ messageLoginApple() }}</span>
        </button>
        <!--
        <button class="btn-acceder btn-acceder-icon-left" routerLink="/acceso/options/registrate" (click)="loginFacebook()">
          <img src="/assets/images/pages/options-auth/logo-facebook.svg"/>
          <p>{{ messageLoginFacebook() }}</p>
        </button>
        -->
      </div>
      <div class="descubre">
        @if (mode=='acceder') {
          <p>¿Todavia no tines cuenta? <a (click)="navto()">Registrate</a></p>
        }
        @if (mode=='registrate') {
          <p>¿Ya tienes una cuenta? <a (click)="navto()">Acceder</a></p>
        }
      </div>
    </div>
  </div>
</div>